// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zqwU","content":"styles_content__1MMFc","row":"styles_row__tpHyS","footer":"styles_footer__1I10t","phraseLength":"styles_phraseLength__ijD_e"};